import { render, staticRenderFns } from "./EditLedger.vue?vue&type=template&id=2b5b7b6c&"
import script from "./EditLedger.vue?vue&type=script&lang=js&"
export * from "./EditLedger.vue?vue&type=script&lang=js&"
import style0 from "./EditLedger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports